<template>
    <div id="app">
        <HomeBottomNav></HomeBottomNav>
        <keep-alive>
            <router-view />
        </keep-alive>
    </div>
</template>

<script>
import HomeBottomNav from "@/components/HomeBottomNav.vue";

export default {
    components: {
        HomeBottomNav
    }
};
</script>
<style lang="less"></style>
